// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"Notifications_btnWrapper__6Ma2T","cancelBtn":"Notifications_cancelBtn__2GKEW","saveBtn":"Notifications_saveBtn__3vcz-"};